import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Post, PostStatus } from '@/types';

/**
 * Posts Feature Slice
 * 
 * Manages local UI state for posts (filters, selected post, etc.)
 * Data fetching is handled by RTK Query in services/api/endpoints/posts.ts
 */

interface PostsState {
  filters: {
    status?: PostStatus;
    departmentId?: string;
    searchQuery?: string;
  };
  selectedPostId: string | null;
  viewMode: 'grid' | 'list';
}

const initialState: PostsState = {
  filters: {},
  selectedPostId: null,
  viewMode: 'grid',
};

const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    setStatusFilter: (state, action: PayloadAction<PostStatus | undefined>) => {
      state.filters.status = action.payload;
    },
    setDepartmentFilter: (state, action: PayloadAction<string | undefined>) => {
      state.filters.departmentId = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string | undefined>) => {
      state.filters.searchQuery = action.payload;
    },
    clearFilters: (state) => {
      state.filters = {};
    },
    setSelectedPost: (state, action: PayloadAction<string | null>) => {
      state.selectedPostId = action.payload;
    },
    setViewMode: (state, action: PayloadAction<'grid' | 'list'>) => {
      state.viewMode = action.payload;
    },
  },
});

export const {
  setStatusFilter,
  setDepartmentFilter,
  setSearchQuery,
  clearFilters,
  setSelectedPost,
  setViewMode,
} = postsSlice.actions;

export default postsSlice.reducer;

